import React from 'react';
import { Redirect } from 'react-router';

import { usePets } from '../context/PetsContext';

/* ---------------------- */
/* Pet Guard HOC          */
/* ---------------------- */
export const withPetGuard = (Component: React.FC) => {
  return () => {
    const { currentPet } = usePets();

    if (!currentPet) {
      return <Redirect to="/tabs/home" />;
    }

    return <Component />;
  };
};
